import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash-es";
import { errorToast } from "shared/toast"

const SLICE_NAME = "groups"

const INITIAL_STATE = {
  groupIdMap: {},
  groups: [],
  loading: true,
}

const buildGroupIdMap = (groups = []) => cloneDeep(groups).reduce((map, group) => {
  map[group.id] = group

  return map
}, {})

export const loadGroups = createAsyncThunk(
  `${SLICE_NAME}/loadGroups`,
  // load expected be a function that returns a list of groups
  // or throws an error if there's a problem getting the groups
  async ({ load }) => {
    const newGroups = await load()

    return { newGroups }
  },
)

export const groupsSlice = createSlice({
  name: SLICE_NAME,
  initialState: cloneDeep(INITIAL_STATE),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadGroups.pending, (state) => {
        state.loading = true
      })
      .addCase(loadGroups.fulfilled, (state, action) => {
        const { newGroups } = action.payload

        state.groupIdMap = buildGroupIdMap(newGroups)
        state.groups = newGroups

        state.loading = false
      })
      .addCase(loadGroups.rejected, (_state, action) => {
        errorToast(action.error.message)
      })
  },
})

export const groupById = (id) => (state) => state[SLICE_NAME].groupIdMap[id]

export const groups = (state) => state[SLICE_NAME].groups

export const groupsById = (ids) => (state) => ids.map((id) => groupById(id)(state))

export const loading = (state) => state[SLICE_NAME].loading

export default groupsSlice.reducer
